import React from 'react';
import PropTypes from 'prop-types';
import LaddaButton from 'App/components/LaddaButton';
import toast from 'Shared/toast';
import useSendMassTextingMutation from 'App/hooks/useSendMassTextingMutation';

const propTypes = {
    isDisabled: PropTypes.bool.isRequired,
    message: PropTypes.string.isRequired,
    patientId: PropTypes.string.isRequired,
    activityId: PropTypes.string.isRequired,
};

const defaultProps = {};

function SendButton({ isDisabled, message, patientId, activityId }) {
    const sendMassTextMutation = useSendMassTextingMutation(false);

    return (
        <LaddaButton
            isLoading={sendMassTextMutation.isLoading}
            disabled={isDisabled}
            variant="primary"
            type="button"
            onClick={() => {
                return sendMassTextMutation
                    .mutateAsync({
                        message,
                        selectedPatients: [patientId],
                        activityId,
                        queueReason: 'adHoc',
                    })
                    .then(() => {
                        toast.success('Successfully queued the message.');
                    });
            }}
        >
            Send
        </LaddaButton>
    );
}

SendButton.propTypes = propTypes;
SendButton.defaultProps = defaultProps;

export default SendButton;
